// 檢查 公司統編規則
function validateUbn (ubn) {
  // 測試用統編
  if (process.env.VUE_APP_ENV === 'development' && ubn === '12345678') {
    return true
  }

  // 儲存各個乘數
  const multiply = [1, 2, 1, 2, 1, 2, 4, 1]

  let caleSum = 0

  // 撰寫「正規表達式」。營利事業統一編號，長度:共八位，，全部為數字型態
  const regExpID = /^\d{8}$/
  // 使用「正規表達式」檢驗格式
  if (ubn.search(regExpID) === -1) {
    // 基本格式錯誤
    return false
  }

  const cnum = ubn.split('')
  for (let i = 0; i < multiply.length; i++) {
    caleSum += _calcCompanySinWeigh(parseInt(cnum[i]) * multiply[i])
  }
  if (caleSum % 5 === 0) {
    return true
  } else if (cnum[6] === '7' && (caleSum + 1) % 5 === 0) {
    return true
  } else {
    return false
  }
}

// 檢查信箱格式是否正確（可空值）
function validateEmail (email) {
  const reg = new RegExp(
    '^[_a-z0-9-]+([.][_a-z0-9-]+)*@[a-z0-9-]+([.][a-z0-9-]+)*$'
  )
  if (!email || reg.test(email)) return true
  else return false
}

// 檢查手機號碼是否正確（可空值）
function validateCellphone (cellphone) {
  const reg = new RegExp(/^09\d{2}\d{3}\d{3}$/)
  if (!cellphone) return true
  else return reg.test(cellphone)
}

// 計算 公司權重值
function _calcCompanySinWeigh (n) {
  if (n > 9) {
    const s = n + ''
    const n1 = parseInt(s.substring(0, 1)) * 1
    const n2 = parseInt(s.substring(1, 2)) * 1
    n = n1 + n2
  }
  return n
}

// 檢查 自動產生編號為「大寫C+７個數字」
function validateCustomUbn (customUbn) {
  const reg = new RegExp(/^C\d{7}$/)
  // 使用「正規表達式」檢驗格式
  if (customUbn.search(reg) === -1) {
    // 基本格式錯誤
    return false
  } else {
    return true
  }
}

export default {
  validateUbn,
  validateEmail,
  validateCellphone,
  validateCustomUbn
}
